<template>
  <div :class="['layout-lesson-count', {'supplied': !!supplyCount}, {true: 'inline', false: 'row'}[inline]]">
    <template v-if="inline">
      <span class="digit">{{lessonCount}}</span>
      <span v-if="supplyCount"
            class="supply">(含{{supplyCount}}人补修)</span>
    </template>
    <template v-else>
      <div class="digit">{{lessonCount}}</div>
      <div v-if="supplyCount"
           class="supply">(含{{supplyCount}}人补修)</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'LessonCount',
  props: {
    lessonCount: {
      type: [String, Number],
      default: 0
    },
    supplyCount: [String, Number],
    inline: Boolean
  }
}
</script>

<style lang="scss">
  .layout-lesson-count {
    &.row {
      &.supplied {
        line-height: 120%;
        padding-top: 8px;
        padding-bottom: 8px;
      }
      & > .supply {
        margin-top: 2px;
        transform: scale(.9);
      }
    }
    &.inline {
      overflow: hidden;
      text-overflow: ellipsis;
      & > .supply {
        margin-left: 4px;
      }
    }
  }
</style>
